import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { sendEmailVerification } from '../../actions';
import styled from 'styled-components';
import { SuccessHelper, ErrorHelper } from '../../components/Lock';

const EmailSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const EmailSectionItem = styled.div`
  margin-right: 10px;
`;


class EmailSettings extends React.Component {

  sendEmailVerification = () => {
    this.props.sendEmailVerification(this.props.accessToken)
  };

  render() {
    const {profile} = this.props;

    const emailStatus = profile.email_verified
      ? <SuccessHelper text="Verified"/>
      : <ErrorHelper text="Unverified"/>;

    const verificationLink = profile.email_verified
      ? null
      : (
        <a role="button" onClick={this.sendEmailVerification}>
          (resend verification)
        </a>
      );

    return (
      <EmailSection>
        <EmailSectionItem>{profile.email}</EmailSectionItem>
        <EmailSectionItem>{emailStatus}</EmailSectionItem>
        <EmailSectionItem>{verificationLink}</EmailSectionItem>
      </EmailSection>
    )
  }
}

function mapStateToProps(state) {
  return {
    profile: state.profile,
    accessToken: state.accessToken
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    sendEmailVerification
  }, dispatch)
}


EmailSettings = connect(mapStateToProps, mapDispatchToProps)(EmailSettings);

export default EmailSettings;



// WEBPACK FOOTER //
// ./src/containers/EmailSettings/index.js